import { AppLoadService } from '@shared/modules/app/components/app-load.service';
import { Observable } from 'rxjs';

export function initApp(appLoadService: AppLoadService): () => Observable<any> {
  return () => appLoadService.initApp();
}
